import React from 'react';
import PageLayout from "../../components/PageLayout/PageLayout";
import '../bookpage.css'
import Title from '../../components/Title/Title';

export default function ReplaceFleshlyThoughts() {
  return (
    <PageLayout>
      <div className="book-page">
        <Title title="Replace fleshly thoughts with spiritual" />
        <blockquote>
          “For the mind set on the flesh is death, but the mind set on the Spirit is life and peace.” (Romans 8:6)
        </blockquote>

        <p>Temptation must persuade our minds to think, speak, or do something that is contrary to God’s commands. Our bodies don’t move or speak without the express direction of our minds, nor can our flesh be proud without our minds thinking proud thoughts. Temptation has to win the battle for the mind or it cannot succeed in making us sin. Therefore, we must carefully guard our minds and what we allow our minds to think. But simply telling ourselves not to think about a particular thing can be very difficult, like telling a person to not think of a pink elephant; the conscious effort of trying to not think about something can be counterproductive. Much more effective is the practice of filling our minds with thoughts opposite that of the temptation, that is, filling our minds with spiritual thoughts and God’s truth. Since Satan’s strategy is to get into our face with the temptation and fill our minds with thoughts of it, to make it seem appealing and irresistible, and since his strategy is to crowd out any opposition to his lies, so must our strategy be to replace his lies with spiritual thoughts and push out any opposition to God’s truth. Force temptation out of your mind by filling it overflowing with God’s truth, fixing your mind on the things above. As you do this repeatedly and habitually, you will find that temptation no longer has the power or appeal it once had, and it will be much more difficult to sin when your mind is fixed on the things above. Replace sinful thoughts with spiritual thoughts.</p>
        <br />

        <ul>
          <li>
            <strong>Set your mind on the things above, not the things on the earth; renew your mind.</strong><br />
            <em>Romans 12:1-2, Ephesians 4:23, Colossians 3:1-4</em>
          </li>
          <br />
          <li>
            <strong>Fill your mind with Scripture, and keep the Word of God in the forefront of your mind.</strong><br />
            <em>Joshua 1:8, Psalm 1:2, 18:21-23, 119:9-11, John 8:31-32</em>
          </li>
          <br />
          <li>
            <strong>Dwell on the things that are true, honorable, right, pure, lovely, of good repute, excellent, and praiseworthy.</strong><br />
            <em>Philippians 4:8</em>
          </li>
          <br />
          <li>
            <strong>Fix your hope completely on the grace to be brought to you at the revelation of Jesus Christ; look forward to God’s reward.</strong><br />
            <em>2 Timothy 4:8, 1 Peter 1:13, Hebrews 11:26</em>
          </li>
          <br />
          <li>
            <strong>Replace a negative, fearful attitude with trusting faith and boldness.</strong><br />
            <em>Matthew 14:26-33, Mark 11:22-24, John 14:1, Revelation 21:8</em>
          </li>
          <br />
          <li>
            <strong>Believe His Word and promises to be true!</strong><br />
            <em>Hebrews 11:1-40</em>
          </li>
          <br />
          <li>
            <strong>Keep on praying; pray without ceasing.</strong><br />
            <em>Luke 18:1, Colossians 4:2, 1 Thessalonians 5:17</em>
          </li>
          <br />
          <li>
            <strong>Seek God with all your heart. Present your members to Him as instruments of righteousness.</strong><br />
            <em>Psalm 63:1, 119:2-3, 10, Isaiah 26:8-9, 55:6, Romans 6:13</em>
          </li>
          <br />
          <li>
            <strong>Proactively pursue righteousness, hasten to keep God’s commandments, sow to the Spirit, do the things that help others and further God’s kingdom.</strong><br />
            <em>Psalm 119:59-60, Matthew 6:33, Romans 14:19, Galatians 6:8-9, 2 Timothy 2:22</em>
          </li>
        </ul>

      </div>
    </PageLayout>
  );
};
